import type { DialoguePool } from '@/state/types';

export const L20_DIALOGUE: DialoguePool = {
  slowPlay: [
    'Your last cowardly checkpoint. Use it. Don\u2019t use it. I\u2019m keeping score either way.',
    'Column B is wide open. I left it that way for you.',
    'A second save. Imagine the paperwork. I already have.',
  ],
  tokenLoss: [
    'You cannot lose tokens at a checkpoint. Only standing.',
    'The slot is not a toy. Yet here we are. Toying.',
    'A wasted click. The logs note it anyway. Column H, this time.',
  ],
  solution: [
    'Both checkpoints. You\u2019ve achieved something. I\u2019m not sure what. It\u2019s in column F.',
    'Another save. Another scar. The token bank is getting scenic.',
    'Brave. Again. Or stupid. Again. The logs cannot decide.',
  ],
  spite: ['Hello again, coward. The second scar is my favourite of yours.'],
};
